import React, {forwardRef, useEffect, useImperativeHandle, useState} from 'react';
import {Multiselect} from 'multiselect-react-dropdown';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import './TwoWayModal.scss';
import './TwoWayModalLocationSelect.scss';
import Spinner from '../Spinner/Spinner';
import LocationService from '../../Store/LocationsService/LocationsService';

const TwoWayModalPatientSelect = forwardRef((props, ref) => {
  const [locations, setLocations] = useState([]);
  const [hasLocations, setHasLocations] = useState(false);
  const [isOpen, setIsOpen] = useState(true);
  const [selectedPatient, setSelectedPatient] = useState({});
  const [open, setOpen] = useState(false);

  const patientNames = () => {
    var patientNamesArray = [];
    for (var patient in props.patientDictionary) {
      patientNamesArray.push({'name': patient})
    }
    return patientNamesArray;
  }

  useImperativeHandle(ref, () => ({
    setAlert(e) {
      handleOpen();
      setIsOpen(true)
    },
    closeAlert(e) {
      handleClose();
    }

  }));

  const handleOpen = () => {
    setOpen(true);
    setIsOpen(true)
  };

  const handleClose = () => {
    setOpen(false);
    setIsOpen(false)
  };
  const handleConfirmSelectedPatient = (e) => {
    props.updateSelectPatient(e);
    handleClose();
  };
  const handleSelectedPatient = (e) => {
    props.selectedPatient(e[0])
    setSelectedPatient(props.selectedPatient(e[0]))
  }

  useEffect(() => {
    // Use get Find patients here
    setLocations(LocationService.getCacheLocations())
  }, [isOpen])

  return (
    <>
      <Dialog
        disableBackdropClick={true}
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className='TwoWayModalLocationSelect'
      >
        <DialogTitle id="alert-dialog-title">{props.heading}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {props.body}
          </DialogContentText>

          {<Multiselect
            textInputProps={{editable: false, autoFocus: false}}
            options={patientNames()}
            singleSelect
            displayValue="name"
            placeholder="Select patient"
            disable={false}
            avoidHighlightFirstOption
            onSelect={handleSelectedPatient}
          />}
        </DialogContent>

        {props.spinner && <span className='spinner-centered'><Spinner/></span>}

        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {props.button1}
          </Button>
          <Button onClick={handleConfirmSelectedPatient} color="primary" autoFocus>
            {props.button2}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
})

export default TwoWayModalPatientSelect;